import React, { ReactNode } from 'react'

import { SessionProvider as RASessionProvider } from '@/shared/contexts'
import { useSession } from '@/shared/hooks'

export const SessionProvider = ({ children }) => {
  const { data: session } = useSession()

  return <RASessionProvider session={session}>{children}</RASessionProvider>
}
